import * as AiIcons from 'react-icons/ai'
import * as IoIcons from 'react-icons/io'
import * as BsIcons from 'react-icons/bs'
import * as GoIcons from 'react-icons/go'
import * as TbIcons from "react-icons/tb";
import * as HiIcons from "react-icons/hi";
import * as SiIcons from "react-icons/si";
import * as LiaIcons from "react-icons/lia";
import * as RxIcons from "react-icons/rx";
import * as PiIcons from "react-icons/pi";
import * as LuIcons from "react-icons/lu";

import customIcons from './customIcons'

import * as DiIcons from "react-icons/di";
import * as FiIcons from "react-icons/fi";
import * as FcIcons from "react-icons/fc";
import * as Hi2Icons from "react-icons/hi2";
import * as Io5Icons from "react-icons/io5";
import * as SlIcons from "react-icons/sl";
import * as TfIcons from "react-icons/tfi";
import * as CgIcons from "react-icons/cg";

// Apache License Version 2.0
import * as MdIcons from 'react-icons/md'
import * as GrIcons from "react-icons/gr";
import * as RiIcons from "react-icons/ri";

//DO NOT USE:
import * as biIcons from "react-icons/bi";
import * as ciIcons from "react-icons/ci";
import * as faIcons from "react-icons/fa";
import * as giIcons from "react-icons/gi";
import * as imIcons from "react-icons/im";
import * as siIcons from "react-icons/si";
import * as tiIcons from "react-icons/ti";
import * as vsIcons from "react-icons/vsc";
import * as wiIcons from "react-icons/wi";

import { productGroupIconSvg } from './customIcons';


// Icons for Navigation
export const Icon_Apps = <MdIcons.MdOutlineApps />
export const Icon_Download = <MdIcons.MdDownload />
export const Icon_Org = <BsIcons.BsBuilding />
export const Icon_People=  <Hi2Icons.HiOutlineUsers />
export const Icon_Gear =  <GoIcons.GoGear />
export const Icon_Back = <IoIcons.IoMdArrowBack />
export const Icon_Home = <GoIcons.GoHome />
export const Icon_Boxes = <BsIcons.BsBoxes />
export const Icon_Paper = <Io5Icons.IoDocumentOutline />
export const Icon_Message = <BsIcons.BsEnvelopeOpenFill />
export const Icon_Help = <IoIcons.IoMdHelpCircle />
export const Icon_Cart = <MdIcons.MdLocalGroceryStore />
export const Icon_Invoice = <LiaIcons.LiaFileInvoiceDollarSolid />

// Icons for Apps List
export const Icon_PeopleFill = <BsIcons.BsFillPeopleFill />
export const Icon_Factory = <TbIcons.TbBuildingFactory2 />
export const Icon_Books = <SiIcons.SiBookstack />
export const Icon_CustomerService =<AiIcons.AiFillCustomerService />
export const Icon_Inventory = <MdIcons.MdInventory />
export const Icon_Task = <MdIcons.MdTask />
export const Icon_Kanban = <TbIcons.TbLayoutKanban />

export const Icon_Arrow_Right = <AiIcons.AiOutlineRight />
export const Icon_Arrow_Left = <AiIcons.AiOutlineLeft />
export const Icon_Edit = <AiIcons.AiFillEdit />
export const Icon_Plus = <HiIcons.HiPlus />
export const Icon_Search = <MdIcons.MdSearch />
export const Icon_Alert = <GoIcons.GoAlertFill />
export const Icon_Delete = <MdIcons.MdDeleteForever />

export const Icon_Arrow_Left_Circle = <BsIcons.BsArrowLeftCircleFill />
export const Icon_Arrow_Right_Circle = <BsIcons.BsArrowRightCircleFill />
export const Icon_Arrow_Left_Simple= <BsIcons.BsArrowLeft />
export const Icon_Arrow_Right_Simple = <BsIcons.BsArrowRight />

export const Icon_Design = <MdIcons.MdOutlineDesignServices />

//Icons for Uploader
export const Icon_CheckMark = <AiIcons.AiOutlineCheckCircle />
export const Icon_Upload = <AiIcons.AiOutlineCloudUpload />  
export const Icon_Clear = <MdIcons.MdClear />
// Purchases › Inbox: documents dropped before they are expenses (38.04)
export const Icon_Inbox = <MdIcons.MdOutlineInbox />

//Drag Component
export const Icon_Drag = <RxIcons.RxDragHandleDots2 />


//Entry Icons
export const Icon_Check = <IoIcons.IoMdCheckmark />
export const Icon_InfoCircle = <MdIcons.MdInfo />
export const Icon_Money = <TbIcons.TbPigMoney />

export const Icon_CreditNote =<BsIcons.BsFileEarmarkMinus />
export const Icon_Quote = <BsIcons.BsFileEarmarkText />
export const Icon_Interaction = <AiIcons.AiFillInteraction />

export const Icon_Briefcase = <HiIcons.HiBriefcase />
export const Icon_Contacts = <RiIcons.RiContactsBook3Line />
export const Icon_Purchases = <Io5Icons.IoPricetagsOutline /> 
export const Icon_Location = <Io5Icons.IoLocationOutline /> 
export const Icon_Warehouse = <TbIcons.TbBuildingWarehouse />
export const Icon_Rack = <MdIcons.MdShelves />
export const Icon_Hall = <PiIcons.PiWarehouse />
export const Icon_Pallet = <MdIcons.MdPallet />
export const Icon_StockMovement = <GoIcons.GoPackageDependents />
export const Icon_StockAdjustment = <LuIcons.LuPackagePlus /> 
export const Icon_Shipment = <MdIcons.MdOutlineLocalShipping />
export const Icon_Receipt = <TfIcons.TfiTruck /> 
export const Icon_Lock = <MdIcons.MdLockOutline />
export const Icon_Unlock = <MdIcons.MdLockOpen />
export const Icon_Bank = <RiIcons.RiBankLine />
export const Icon_Transaction = <GrIcons.GrTransaction />
export const Icon_Sync = <IoIcons.IoMdSync />
export const Icon_Price = <Io5Icons.IoPricetagOutline />
export const Icon_Megaphone = <RiIcons.RiMegaphoneLine />
export const Icon_PeopleGroup = <Hi2Icons.HiOutlineUserGroup />
export const Icon_Dots = <BsIcons.BsThreeDots />
export const Icon_Send = <MdIcons.MdSend />
export const Icon_Mail = <IoIcons.IoMdMail />
export const Icon_Save = <IoIcons.IoIosSave />
export const Icon_Close = <IoIcons.IoIosCloseCircle />
export const Icon_GenerateList = <MdIcons.MdFormatListBulletedAdd />
export const Icon_Funnel = <IoIcons.IoIosFunnel />
export const Icon_Sliders = <LiaIcons.LiaSlidersHSolid />
export const Icon_ProductGroup = <LiaIcons.LiaBoxesSolid />
export const Icon_World = <TbIcons.TbWorld />
export const Icon_Planner = <TbIcons.TbCalendarTime />
export const Icon_Play = <AiIcons.AiOutlinePlayCircle />
export const Icon_Document = <MdIcons.MdOutlineDescription />
export const Icon_Folder = <MdIcons.MdOutlineFolder />
export const Icon_Manufacturing = <TbIcons.TbBuildingFactory2 />
export const Icon_Pointer = <TbIcons.TbPointer />
export const Icon_Move = <TbIcons.TbArrowsMove />
export const Icon_Route = <TbIcons.TbRoute />
export const Icon_Rectangle = <TbIcons.TbRectangle />
export const Icon_Fit = <TbIcons.TbArrowsMaximize />
export const Icon_Reset = <TbIcons.TbRestore />
export const Icon_Attachment = <AiIcons.AiOutlinePaperClip />

/**
 * Aggregate icon map for config/data files (see model/components/cardViewData/).
 * Lets a data file keep one stable import line instead of a named-import list
 * that has to be maintained as entries are added, moved, or removed.
 *
 * JSX components should keep importing the named `Icon_*` exports directly.
 */
export const icon = {
    apps            : Icon_Apps,
    download        : Icon_Download,
    org             : Icon_Org,
    people          : Icon_People,
    gear            : Icon_Gear,
    back            : Icon_Back,
    home            : Icon_Home,
    boxes           : Icon_Boxes,
    paper           : Icon_Paper,
    attachment      : Icon_Attachment,
    message         : Icon_Message,
    help            : Icon_Help,
    cart            : Icon_Cart,
    invoice         : Icon_Invoice,
    peopleFill      : Icon_PeopleFill,
    factory         : Icon_Factory,
    books           : Icon_Books,
    customerService : Icon_CustomerService,
    inventory       : Icon_Inventory,
    task            : Icon_Task,
    kanban          : Icon_Kanban,
    arrowRight      : Icon_Arrow_Right,
    arrowLeft       : Icon_Arrow_Left,
    edit            : Icon_Edit,
    plus            : Icon_Plus,
    search          : Icon_Search,
    alert           : Icon_Alert,
    delete          : Icon_Delete,
    arrowLeftCircle : Icon_Arrow_Left_Circle,
    arrowRightCircle: Icon_Arrow_Right_Circle,
    arrowLeftSimple : Icon_Arrow_Left_Simple,
    arrowRightSimple: Icon_Arrow_Right_Simple,
    design          : Icon_Design,
    checkMark       : Icon_CheckMark,
    upload          : Icon_Upload,
    clear           : Icon_Clear,
    drag            : Icon_Drag,
    check           : Icon_Check,
    infoCircle      : Icon_InfoCircle,
    money           : Icon_Money,
    creditNote      : Icon_CreditNote,
    quote           : Icon_Quote,
    interaction     : Icon_Interaction,
    briefcase       : Icon_Briefcase,
    contacts        : Icon_Contacts,
    purchases       : Icon_Purchases,
    location        : Icon_Location,
    warehouse       : Icon_Warehouse,
    rack            : Icon_Rack,
    hall            : Icon_Hall,
    pallet          : Icon_Pallet,
    stockMovement   : Icon_StockMovement,
    stockAdjustment : Icon_StockAdjustment,
    shipment        : Icon_Shipment,
    receipt         : Icon_Receipt,
    lock            : Icon_Lock,
    unlock          : Icon_Unlock,
    bank            : Icon_Bank,
    transaction     : Icon_Transaction,
    sync            : Icon_Sync,
    price           : Icon_Price,
    megaphone       : Icon_Megaphone,
    peopleGroup     : Icon_PeopleGroup,
    dots            : Icon_Dots,
    send            : Icon_Send,
    mail            : Icon_Mail,
    save            : Icon_Save,
    close           : Icon_Close,
    generateList    : Icon_GenerateList,
    funnel          : Icon_Funnel,
    sliders         : Icon_Sliders,
    productGroup    : Icon_ProductGroup,
    world           : Icon_World,
    planner         : Icon_Planner,
    play            : Icon_Play,
    document        : Icon_Document,
    folder          : Icon_Folder,
    manufacturing   : Icon_Manufacturing,
    pointer         : Icon_Pointer,
    move            : Icon_Move,
    route           : Icon_Route,
    rectangle       : Icon_Rectangle,
    fit             : Icon_Fit,
    reset           : Icon_Reset,
    inbox           : Icon_Inbox
}

/**
 * The element for a config icon (30.03.01 §4).
 *
 * Model files name icons by their key in the map above — `icon: 'save'` — so a
 * model file is plain JSON: it can be stored as an overlay, merged on the
 * server and sent over the wire. Every component that renders a config icon
 * resolves it here, at the point it is drawn. An element passes through
 * unchanged, so a component can be handed either form, and an icon a JSX
 * component imports directly still works.
 *
 * An unknown key renders nothing and warns once in development, so a typo
 * shows up in the console instead of as an empty space nobody notices.
 */
const warnedIcons = new Set()
export function resolveIcon(value) {
    if (typeof value !== 'string') return value
    const el = icon[value]
    if (el === undefined) {
        if (import.meta.env?.DEV && !warnedIcons.has(value)) {
            warnedIcons.add(value)
            console.warn(`[icons] unknown icon key "${value}"`)
        }
        return null
    }
    return el
}
